export const getMapPaymentType = (t: (key: string) => string): Record<string, string> => ({
  income: t('managePage.transactionPage.common.income'),
  expense: t('managePage.transactionPage.common.expense')
});
